import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";

const ButtonOffset = (props) => {
  console.log("props ", props.whatOffset);

  return (
    <div className="wrapper-offset">
      <Suspense fallback={"...Loading"}>
        <Translation>
          {(t, { i18n }) => (
            <Link
              to="/"
              className={
                props.whatOffset === "tree"
                  ? "button-offset button-offset-tree active"
                  : "button-offset button-offset-tree"
              }
            >
              <img src="/icon-tree.png" alt="Jejak - Plant Tree" />{" "}
              {t("ButtonOffsets.btn_pohon")}
            </Link>
          )}
        </Translation>
      </Suspense>

      {/* <Link to="/carbon" className={props.whatOffset === 'carbon' ? 'button-offset button-offset-carbon active' : 'button-offset button-offset-carbon'}>
            <img src="/icon-carbon.png" alt="Jejak - Carbon Offsets" /> KARBON
         </Link> */}
    </div>
  );
};
export default ButtonOffset;
